(function() {
	/**
	 * Switch image when you hover feature box
	 */

	const imageHoverLoaders = document.querySelectorAll('.js-image-hover-loader');
	Array.prototype.forEach.call(imageHoverLoaders, function(imageHoverLoader) {
		imageHoverLoader.addEventListener('mouseenter', function() {
			const target = document.querySelector(this.getAttribute('data-target'));
			const src = this.getAttribute('data-url');

			// preload image to prevent blank view during loading
			var downloadingImage = new Image();
			downloadingImage.onload = function() {
				console.log(target.src, src);

				if (target.tagName !== 'IMG') {
					// Faster variant than target.innerHTML = '';
					// We delete content of target because there can be eg. video
					while (target.firstChild) {
						target.removeChild(target.firstChild);
					}

					target.style['background-image'] = 'url(' + src + ')';
				} else {
					target.src = src;
				}
			};
			downloadingImage.src = src;
		});
	});
})();
